/**
 * Pure mapping: AddToProduct payload texts → the SAME suggestion data
 * structure the channel-editor stack consumes.
 *
 * Instead of duplicating the closed-enum field mapping and the
 * bullets→Bullet1..5 mapping, we synthesize a `RemakeJury` from the payload
 * texts and hand it to the EXISTING `remakeSuggestion` helpers
 * (`buildSuggestionFields` lines ~33-37, `buildBulletSuggestions` lines
 * ~40-48). Single source of truth — zero duplication.
 */

import type { RemakeJury } from '@/components/v2/tools/amazon-listing/RemakeApply/remakeSuggestion'
import type { AddToProductTextField } from './types'

/**
 * Build a synthetic Remake jury variant from payload text fields.
 * Returns null when there are no texts (mirrors `getJuryVariant(null)`),
 * so `buildSuggestionFields(null)` / `buildBulletSuggestions(null)` yield {}.
 */
export function buildSuggestionFieldsFromTexts(
  texts: AddToProductTextField[],
): RemakeJury | null {
  if (!texts || texts.length === 0) return null

  let title = ''
  let description = ''
  let searchTerms = ''
  let bullets: string[] = []

  for (const t of texts) {
    if (t.kind === 'bullets') {
      bullets = t.values
    } else if (t.field === 'title') {
      title = t.value
    } else if (t.field === 'description') {
      description = t.value
    } else if (t.field === 'keywords') {
      searchTerms = t.value
    }
  }

  return {
    agent_style: 'payload',
    title,
    description,
    bullets,
    backend_keywords: { search_terms: searchTerms },
  }
}
